__turbopack_context__.v({
  "highlighted": "app-sidebar-module__XLkISa__highlighted",
  "partner-shimmer": "app-sidebar-module__XLkISa__partner-shimmer",
});
